import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Avatar from '@99designs/react-components/components/Avatar';
import Button from '@99designs/react-components/components/Button';
import Icon from '@99designs/react-components/components/Icon';
import ButtonGroup, { ButtonGroupItem } from '@99designs/react-components/components/ButtonGroup';
import ConfirmationPopup from './confirmation-popup';
import FixedViewportElement from '@99designs/fullscreen/components/FixedViewportElement';
import { Matrix, MatrixItem } from 'contest/components/matrix';
import AvatarPlaceholder from './avatar-placeholder';
import { times } from 'lodash';
import pluralSelect from '../../../utils/plural-select';

class ContestFinalistFullscreenDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = { isActive: false };
    }

    render() {
        const classes = classNames({
            'fullscreen-drawer': true,
            'fullscreen-drawer--active': this.state.isActive,
        });
        const finalistCount = this.props.finalists.length;
        return (
            <FixedViewportElement isEnabled={this.state.isActive}>
                <div className={classes}>
                    <div
                        className="fullscreen-drawer__header"
                        onClick={() => this.setState({ isActive: !this.state.isActive })}
                    >
                        <span className="fullscreen-drawer__header__title">
                            <FormattedMessage
                                id={pluralSelect(finalistCount, {
                                    one: 'contest_finalist_fullscreen_drawer_header_one',
                                    other: 'contest_finalist_fullscreen_drawer_header_other',
                                })}
                                values={{ finalistCount }}
                            />
                        </span>
                        {this.renderFinalistsCount(finalistCount)}
                        <Icon variations={[this.state.isActive ? 'down-2' : 'up-2']} />
                    </div>
                    <div className="fullscreen-drawer__content">
                        <div className="fullscreen-drawer__content__inner">
                            <Matrix small={3} medium={4}>
                                {times(this.props.maxFinalists, index => (
                                    <MatrixItem key={`item-${index}`}>
                                        {this.renderFinalist(index)}
                                    </MatrixItem>
                                ))}
                            </Matrix>
                            <div className="fullscreen-drawer__content__footer">
                                {this.renderButtons(this.props.buttonLayout)}
                            </div>
                        </div>
                    </div>
                </div>
            </FixedViewportElement>
        );
    }

    renderFinalistsCount(finalistsCount) {
        if (finalistsCount) {
            const showConfirmationPopup = this.props.finalistsNeedingPopup.length > 0;
            return (
                <ConfirmationPopup
                    isActive={showConfirmationPopup}
                    variations={['small']}
                    content={<FormattedMessage id="contest_finalist_drawer_confirmation" />}
                >
                    <span className="fullscreen-drawer__header__count">({finalistsCount})</span>
                </ConfirmationPopup>
            );
        }
    }

    renderButtons(type) {
        const finalistCount = this.props.finalists.length;
        return (
            <ButtonGroup variations={[type]}>
                <ButtonGroupItem>
                    <Button
                        variations={['fluid', 'primary']}
                        onClick={this.props.onConfirm}
                        isDisabled={!this.props.finalists.length}
                    >
                        <FormattedMessage
                            id={pluralSelect(finalistCount, {
                                zero: 'contest_finalist_fullscreen_drawer_button_confirm_zero',
                                one: 'contest_finalist_fullscreen_drawer_button_confirm_one',
                                other: 'contest_finalist_fullscreen_drawer_button_confirm_other',
                            })}
                        />
                    </Button>
                </ButtonGroupItem>
                <ButtonGroupItem>
                    <Button
                        variations={['fluid', 'secondary']}
                        onClick={() => this.setState({ isActive: false })}
                    >
                        <FormattedMessage id="contest_finalist_fullscreen_drawer_button_cancel" />
                    </Button>
                </ButtonGroupItem>
            </ButtonGroup>
        );
    }

    renderFinalist(index) {
        if (index < this.props.finalists.length) {
            const user = this.props.finalists[index];
            return (
                <div className="drawer-item drawer-item--fluid drawer-item--circular">
                    <div className="drawer-item__content">
                        <Avatar
                            user={user}
                            variations={['fluid', 'with-shadow']}
                            isLinked={false}
                        />
                    </div>
                    <div className="drawer-item__display-name">{user.displayName}</div>
                    <div className="drawer-item__remove">
                        <button
                            className="solid-icon-button"
                            onClick={() => this.props.onRemoveFinalistClick(user)}
                        >
                            <Icon variations={['x-3']} />
                        </button>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="drawer-item drawer-item--fluid">
                    <AvatarPlaceholder size={48} />
                </div>
            );
        }
    }
}

ContestFinalistFullscreenDrawer.propTypes = {
    maxFinalists: PropTypes.number,
    finalistsNeedingPopup: PropTypes.array.isRequired,
    finalists: PropTypes.arrayOf(
        PropTypes.shape({
            userId: PropTypes.number.isRequired,
            avatarUrl: PropTypes.string.isRequired,
            displayName: PropTypes.string.isRequired,
        })
    ).isRequired,
    onConfirm: PropTypes.func.isRequired,
    onRemoveFinalistClick: PropTypes.func.isRequired,
    buttonLayout: PropTypes.oneOf(['fluid', 'stacked']).isRequired,
};

export default ContestFinalistFullscreenDrawer;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/contest-finalist-fullscreen-drawer.jsx